export default function AboutLeo() {
  return (
    <section className="py-32 px-8 bg-[#faf8f3]">
      <div className="max-w-7xl mx-auto">
        {/* Encabezado */}
        <div className="mb-16">
          <span className="text-gray-500 text-sm uppercase tracking-wider">
            Experiencia Comprobada
          </span>
          <div className="mt-6 max-w-4xl ml-auto">
            <p className="text-3xl text-gray-800 leading-relaxed">
              Con experiencia en el sector de seguros y planificación financiera, he dedicado mi carrera a ayudar a familias y profesionales a construir un futuro seguro y próspero. Mi pasión es educar y proteger el patrimonio de mis clientes.
            </p>
          </div>
        </div>

        {/* Grid de estadísticas */}
        <div className="grid md:grid-cols-2 gap-x-20 gap-y-16 mt-20">
          {/* Fila superior */}
          <div className="space-y-3">
            <div className="text-7xl font-bold text-[#2d5a8f]">98%</div>
            <p className="text-gray-600 text-lg">
              Años de experiencia en seguros y planificación financiera
            </p>
          </div>

          <div className="space-y-3">
            <div className="text-7xl font-bold text-[#2d5a8f]">200+</div>
            <p className="text-gray-600 text-lg">
              Familias protegidas financieramente con el Método FEP
            </p>
          </div>

          {/* Fila inferior */}
        </div>

        {/* Certificaciones y logros */}
        <div className="mt-24 bg-white rounded-3xl p-12 shadow-lg">
          <h3 className="text-3xl font-bold text-[#1a2332] mb-8 text-center">
            Certificaciones y Reconocimientos
          </h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="w-20 h-20 bg-[#ffd166]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-4xl text-[#ffd166]"></i>
              </div>
              <h4 className="font-semibold text-[#1a2332] mb-2">Asesor Certificado</h4>
              <p className="text-sm text-gray-600">Certificación ante la CNSF</p>
            </div>
            <div className="text-center p-6">
              <div className="w-20 h-20 bg-[#14B8A6]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-trophy-line text-4xl text-[#14B8A6]"></i>
              </div>
              <h4 className="font-semibold text-[#1a2332] mb-2">Top Asesor 2024</h4>
              <p className="text-sm text-gray-600">Reconocimiento por excelencia en servicio al cliente</p>
            </div>
            <div className="text-center p-6">
              <div className="w-20 h-20 bg-[#ff8fa3]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-graduation-cap-line text-4xl text-[#ff8fa3]"></i>
              </div>
              <h4 className="font-semibold text-[#1a2332] mb-2">Educador Financiero</h4>
              <p className="text-sm text-gray-600">Especialista en educación y planificación financiera</p>
            </div>
          </div>
        </div>

        {/* Mi misión */}
        <div className="mt-16 text-center max-w-3xl mx-auto">
          <h3 className="text-2xl font-bold text-[#1a2332] mb-6">Mi Misión</h3>
          <p className="text-lg text-gray-700 leading-relaxed">
            Ayudar a cada persona y familia a alcanzar la <strong>libertad financiera</strong> mediante educación, planificación inteligente y protección estratégica. Creo que todos merecen un futuro seguro y próspero, y estoy comprometido a hacer eso realidad.
          </p>
        </div>
      </div>
    </section>
  );
}
